export const getDefaultValidationResult = () => ({
    isValid: true,
    dataValidation: {},
    messages: [],
});
